import { ReactNode } from "react"
import { useTopnavScroll } from "../hooks/useTopnavScroll"
import useOrientation from "@/hooks/useOrientation"

type Props = {
  children: ReactNode
}

export function TopnavShell({ children }: Props) {
  const { progress } = useTopnavScroll()
  const { isLandscape } = useOrientation()

  const blur = 20 + progress * 20
  const opacity = 0.08 + progress * 0.55

  // 🔥 LANDSCAPE: no header fijo ni glass layer
  if (isLandscape) {
    return (
      <div className="relative w-full">
        <div
          className="
            flex items-center
            h-13
            px-0
          "
        >
          {children}
        </div>
      </div>
    )
  }

  // PORTRAIT: FULL GLASS FIXED HEADER
  return (
    <>
      {/* HEADER LAYER */}
      <div
        className="
          fixed top-0 left-0 right-0
          z-[100]
          pointer-events-none
        "
        style={{
          paddingTop: "env(safe-area-inset-top)",
        }}
      >
        {/* GLASS CORE */}
        <div
          className="absolute inset-0"
          style={{
            backdropFilter: `blur(${blur}px)`,
            WebkitBackdropFilter: `blur(${blur}px)`,

            backgroundColor: `rgba(0,0,0,${opacity})`,

            maskImage:
              "linear-gradient(to bottom, black 50%, transparent 100%)",
            WebkitMaskImage:
              "linear-gradient(to bottom, black 65%, transparent 100%)",
          }}
        />

        {/* CONTENT */}
        <div
          className="
            relative
            flex items-center
            h-13
            px-4
            pointer-events-auto
          "
          style={{
            transform: `translateY(${progress * -4}px)`,
          }}
        >
          {children}
        </div>
      </div>

      {/* spacer iOS */}
      <div className="h-0" />
    </>
  )
}